<template>
  <ModalFilterTransaction v-if="modalShowFilterTransaction" :filter="filter" @closeModal="closeModal"
    @submitFilter="submitFilter" />
  <IndexView />
  <section class="p-6">
    <PageTitle title="Laporan Transaksi" />
    <div class="bg-white rounded-lg py-6 px-5 shadow-lg">
      <div v-if="!isConnected" class="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-4" role="alert">
        <p class="font-bold">Connection Status</p>
        <p>Attempting to connect to real-time updates...</p>
      </div>
      <div id="table-header" class="mb-5 flex justify-between items-end">
        <div class="mb-5 flex justify-between gap-2">
          <AddButton to_url="#" button_text="Filter" button_class="text-base py-2 font-medium" @click="showModal" />

          <!-- Single Dropdown Menu -->
          <div class="relative inline-block text-left">
            <div>
              <button type="button" @click="toggleDropdown"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-blue-500"
                id="menu-button" aria-expanded="true" aria-haspopup="true">
                Print Laporan
                <svg class="-mr-1 ml-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                  fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clip-rule="evenodd" />
                </svg>
              </button>
            </div>

            <!-- Dropdown items -->
            <div v-show="isDropdownOpen"
              class="origin-top-left absolute left-0 mt-2 w-80 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-10"
              role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
              <div class="py-1" role="none">
                <button @click="printItemReport(false, true)"
                  class="text-gray-700 block w-full text-left px-4 py-2 text-sm hover:bg-gray-100" role="menuitem"
                  tabindex="-1">
                  Laporan Penjualan Per Item [Rupiah]
                </button>
                <button @click="printItemReport(true, false)"
                  class="text-gray-700 block w-full text-left px-4 py-2 text-sm hover:bg-gray-100" role="menuitem"
                  tabindex="-1">
                  Laporan Penjualan Per Item [Qty]
                </button>
                <button @click="printItemReport(true, true)"
                  class="text-gray-700 block w-full text-left px-4 py-2 text-sm hover:bg-gray-100" role="menuitem"
                  tabindex="-1">
                  Laporan Penjualan Per Item [Rupiah | Qty]
                </button>
                <button @click="printSalesByCategory()"
                  class="text-gray-700 block w-full text-left px-4 py-2 text-sm hover:bg-gray-100" role="menuitem"
                  tabindex="-1">
                  Laporan Penjualan Per Kategori [PDF]
                </button>
                <button @click="printPaymentReport()"
                  class="text-gray-700 block w-full text-left px-4 py-2 text-sm hover:bg-gray-100" role="menuitem"
                  tabindex="-1">
                  Laporan Pembayaran [PDF]
                </button>
                <button @click="printTransactionReport()"
                  class="text-gray-700 block w-full text-left px-4 py-2 text-sm hover:bg-gray-100" role="menuitem"
                  tabindex="-1">
                  Laporan Transaksi [PDF]
                </button>
                <button @click="printRingkasanPenjualan()"
                  class="text-gray-700 block w-full text-left px-4 py-2 text-sm hover:bg-gray-100" role="menuitem"
                  tabindex="-1">
                  Laporan Ringkasan Penjualan [PDF]
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isLoading" class="flex justify-center items-center py-4">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
      </div>
      <div v-else class="overflow-x-auto">
        <div class="inline-block min-w-full align-middle">
          <div class="overflow-hidden shadow-lg rounded-lg">
            <table class="min-w-full divide-y divide-gray-200">
              <thead class="bg-color-1">
                <tr>
                  <th class="py-3 px-3 border-b text-left">No</th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">
                    Kode
                  </th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">
                    Nama Pelanggan
                  </th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">
                    Order Type
                  </th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">
                    Meja
                  </th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">
                    Marketing
                  </th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">
                    Metode pembayaran
                  </th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">
                    Sub Total
                  </th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">tax</th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">
                    Service Charge
                  </th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">
                    Diskon
                  </th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">
                    Grand Total
                  </th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">
                    Keterangan
                  </th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">
                    Bayar
                  </th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">
                    Waktu Transaksi
                  </th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">
                    Status
                  </th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">
                    Cash Register
                  </th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">
                    ACTION
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="transaction in salesOrderData" :key="transaction.id">
                  <td class="py-3 px-3 border-b text-left">
                    {{ transaction.id }}
                  </td>
                  <td class="py-3 px-3 border-b text-left">
                    {{ transaction.code }}
                  </td>
                  <td class="py-3 px-3 border-b text-left">
                    {{ transaction.customer_name }}
                  </td>
                  <td class="py-3 px-3 border-b text-left">
                    {{ transaction.order_type }}
                  </td>
                  <td class="py-3 px-3 border-b text-left">
                    {{this.allTables?.find(t => t.id == transaction.table_id)?.name}}
                  </td>
                  <td class="py-3 px-3 border-b text-left">
                    {{this.allMarketings?.find(m => m.id == transaction.marketing_id)?.name}}
                  </td>
                  <td class="py-3 px-3 border-b text-left">
                    {{this.allPaymentMethods?.find(pm => pm.id == transaction.payment_method_id)?.name}}
                  </td>
                  <td class="py-3 px-3 border-b text-left">
                    {{ this.formatRupiah(transaction.sub_total) }}
                  </td>
                  <td class="py-3 px-3 border-b text-left">
                    {{ this.formatRupiah(transaction.tax) }}
                  </td>
                  <td class="py-3 px-3 border-b text-left">
                    {{ this.formatRupiah(transaction.service_charge) }}
                  </td>
                  <td class="py-3 px-3 border-b text-left">
                    {{ this.formatRupiah(transaction.global_discount_amount) }}
                  </td>
                  <td class="py-3 px-3 border-b text-left">
                    {{ this.formatRupiah(transaction.grand_total) }}
                  </td>
                  <td class="py-3 px-3 border-b text-left">
                    {{ transaction.note }}
                  </td>
                  <td class="py-3 px-3 border-b text-left">
                    {{ this.formatRupiah(transaction.payment_amount) }}
                  </td>
                  <td class="py-3 px-3 border-b text-left">
                    {{ this.formatDate(transaction.updatedAt) }}
                  </td>
                  <td class="py-3 px-3 border-b text-left">
                    {{ transaction.status }}
                  </td>
                  <td class="py-3 px-3 border-b text-left">
                    {{ this.formatDate(transaction.cash_register.time_start) }} - {{
                      this.formatDate(transaction.cash_register.time_end) }}
                  </td>
                  <td class="py-3 px-3 border-b">
                    <RouterLink :to="{ path: '/order', query: { orderId: transaction.id } }"
                      class="border border-gray-400 hover:border-green-700 hover:bg-green-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                      <ShoppingCartIcon class="h-5 w-5" />
                    </RouterLink>
                    <RouterLink :to="{ path: '/payment', query: { orderId: transaction.id } }"
                      class="border border-gray-400 hover:border-blue-700 hover:bg-blue-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                      <EyeIcon class="h-5 w-5" />
                    </RouterLink>
                  </td>
                </tr>
              </tbody>
            </table>
            <PaginationButtons v-model="currentPage" :totalPages="totalPages" />
          </div>
          <Accordion>
            <AccordionPanel value="0">
              <AccordionHeader>Ringkasan Transaksi</AccordionHeader>
              <AccordionContent>
                <div class="mt-6 bg-white dark:bg-dark-800 p-4 rounded-lg shadow">
                  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                    <div class="bg-gray-50 dark:bg-dark-700 p-4 rounded">
                      <p class="text-sm text-gray-500 dark:text-gray-400">Total Transaksi</p>
                      <p class="text-xl font-semibold">{{ allSalesOrders.length }}</p>
                    </div>
                    <div class="bg-gray-50 dark:bg-dark-700 p-4 rounded">
                      <p class="text-sm text-gray-500 dark:text-gray-400">Total Penjualan Item</p>
                      <p class="text-xl font-semibold">{{ formatRupiah(totalRevenueSales) }}</p>
                    </div>
                    <div class="bg-gray-50 dark:bg-dark-700 p-4 rounded">
                      <p class="text-sm text-gray-500 dark:text-gray-400">Total Pajak</p>
                      <p class="text-xl font-semibold">{{ formatRupiah(totalTax) }}</p>
                    </div>
                    <div class="bg-gray-50 dark:bg-dark-700 p-4 rounded">
                      <p class="text-sm text-gray-500 dark:text-gray-400">Total Service Charge</p>
                      <p class="text-xl font-semibold">{{ formatRupiah(totalServiceCharge) }}</p>
                    </div>
                    <div class="bg-gray-50 dark:bg-dark-700 p-4 rounded">
                      <p class="text-sm text-gray-500 dark:text-gray-400">Total Diskon</p>
                      <p class="text-xl font-semibold">{{ formatRupiah(totalDiscount) }}</p>
                    </div>
                    <div class="bg-gray-50 dark:bg-dark-700 p-4 rounded">
                      <p class="text-sm text-gray-500 dark:text-gray-400">Total Complimentary</p>
                      <p class="text-xl font-semibold">{{ formatRupiah(totalComplimentary) }}</p>
                    </div>
                    <div class="bg-gray-50 dark:bg-dark-700 p-4 rounded">
                      <p class="text-sm text-gray-500 dark:text-gray-400">Rata-rata Transaksi</p>
                      <p class="text-xl font-semibold">{{ formatRupiah(averageTransaction) }}</p>
                    </div>
                    <div class="bg-blue-50 dark:bg-blue-900 p-4 rounded border-l-4 border-blue-500">
                      <p class="text-sm text-blue-600 dark:text-blue-300">Total Pendapatan Bersih</p>
                      <p class="text-2xl font-bold text-blue-700 dark:text-white">{{ formatRupiah(totalNetSales) }}</p>
                    </div>
                    <div class="bg-gray-50 dark:bg-dark-700 p-4 rounded">
                      <p class="text-sm text-gray-500 dark:text-gray-400">Total Pax</p>
                      <p class="text-xl font-semibold">{{ totalPax }}</p>
                    </div>
                  </div>
                </div>
              </AccordionContent>
            </AccordionPanel>
          </Accordion>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import PageTitle from "@/components/PageTitle.vue";
  import IndexView from "@/views/IndexView.vue";
  import AddButton from "@/components/buttons/AddButton.vue";
  import ModalFilterTransaction from "./modals/ModalFilterTransaction.vue";
  import { io } from "socket.io-client";
  import { mapGetters } from "vuex";
  import { EyeIcon, ShoppingCartIcon } from "@heroicons/vue/24/solid";
  import axios from "axios";
  import print from "@/helpers/print";
  import { formatRupiah } from "@/helpers/formatRupiah";
  import printPdfReportItem from "@/helpers/prindPdfReportItem";
  import { formatDate, formateISODate, timeSpan } from "@/helpers/formatTime";
  import printPdf from "@/helpers/printPdf";
  import PaginationButtons from "@/components/PaginationButtons.vue";
  import { Accordion, AccordionPanel, AccordionContent, AccordionHeader } from "primevue";
  import printPdfRingkasanPenjualan from "@/helpers/prindPdfRingkasanPenjualan";
  import { calculateAllOrderSummary } from "@/helpers/allSalesOrderCalculation";

  export default {
    name: "TransactionView",
    components: {
      PageTitle,
      IndexView,
      AddButton,
      ModalFilterTransaction,
      EyeIcon,
      ShoppingCartIcon,
      PaginationButtons,
      Accordion,
      AccordionPanel,
      AccordionContent,
      AccordionHeader,
    },
    data() {
      return {
        modalShowFilterTransaction: false,
        isBlur: false,
        listTransaction: [],
        allSalesOrders: [],
        socket: null,
        message: "",
        messages: [],
        isConnected: false,
        isLoading: false,
        currentPage: 1,
        totalPages: 1,
        filter: {},
        isDropdownOpen: false,
        itemsPerPage: 10,
        summaryCashRegister: {},
      };
    },
    async created() {
      this.connectWebSocket();
      await this.fetchSalesOrders();
      await this.fetchAdditionalData();
    },
    computed: {
      // ...mapGetters('sales_orders', ['allSalesOrders']),
      ...mapGetters('tables', ['allTables']),
      ...mapGetters('marketings', ['allMarketings']),
      ...mapGetters('payment_methods', ['allPaymentMethods']),
      ...mapGetters('petty_cash', ['allPettyCashes']),
      ...mapGetters('item_categories', ['allItemCategories']),
      ...mapGetters("settings", ["allSettings"]),
      ...mapGetters("global_discounts", ["allGlobalDiscounts"]),
      reportItem() {
        let reportItem = [];
        const order_paid = this.allSalesOrders?.filter((order) => {
          // const paymentMethod = this.allPaymentMethods?.find((item) => item?.id == order?.payment_method_id);
          // return ((order.status === "paid" && !paymentMethod?.name?.toLowerCase().includes("hutang")) || (paymentMethod?.name?.toLowerCase().includes("hutang") && order?.is_paid_off))
          return order.status === "paid"
        });

        const settings = this.allSettings.length > 0 ? this.allSettings[0] : {};
        order_paid?.forEach(order => {
          // Add order items
          let items = [];
          order?.menus?.forEach((item) => {
            const complimentary = item?.complimentary ? true : false;
            let isExist = items?.findIndex((i) => {
              const icompliment = i?.complimentary ? true : false;
              return i?.item_id == item?.item_id && icompliment === complimentary && i?.discount_applied == item?.discount_applied && i?.tax_applied == item?.tax_applied && i?.service_charge_applied == item?.service_charge_applied && i?.discount_price == item?.discount_price && i?.price == item?.price;
            });

            const isExistGlobalDiscount = this.allGlobalDiscounts?.find((i) => i?.id == order?.global_discount_id)?.amount;
            const service_charge_applied = order?.menus?.find((i) => i?.item_id == item?.item_id && i?.status === "pending")?.service_charge_applied;
            const tax_applied = order?.menus?.find((i) => i?.item_id == item?.item_id && i?.status === "pending")?.tax_applied;
            const discount_applied = order?.menus?.find((i) => i?.item_id == item?.item_id && i?.status === "pending")?.discount_applied;

            const discount_price = parseFloat(item?.discount_price) * Number(item?.qty);
            const revenue_item = parseFloat(item?.price) * Number(item?.qty);
            const revenue_sales = (parseFloat(item?.price) - parseFloat(item?.discount_price)) * Number(item?.qty);
            const bill_discount = isExistGlobalDiscount && discount_applied ? (parseFloat(isExistGlobalDiscount) * parseFloat(revenue_sales) / 100) : 0;
            const tax = tax_applied ? parseFloat(revenue_sales) * Number(settings.tax) / 100 : 0;
            const service_charge = service_charge_applied ? (parseFloat(revenue_sales) - parseFloat(bill_discount)) * Number(settings.service_charge) / 100 : 0;
            const revenue_net_sales = revenue_sales - bill_discount;
            const gross_sales = revenue_sales + tax + service_charge - bill_discount;

            if (isExist == -1) {
              items.push({
                ...item,
                quantity: (item.status == "canceled" ? -1 : 1) * item.qty,
                subtotal: (item.status == "canceled" ? -1 : 1) * item.subtotal,
                total_discount: (item.status == "canceled" ? -1 : 1) * discount_price,
                total_revenue: (item.status == "canceled" ? -1 : 1) * revenue_item,
                total_revenue_sales: (item.status == "canceled" ? -1 : 1) * parseFloat(revenue_sales),
                total_bill_discount: (item.status == "canceled" ? -1 : 1) * parseFloat(bill_discount),
                total_tax: (item.status == "canceled" ? -1 : 1) * parseFloat(tax),
                total_service_charge: (item.status == "canceled" ? -1 : 1) * parseFloat(service_charge),
                total_revenue_net_sales: (item.status == "canceled" ? -1 : 1) * parseFloat(revenue_net_sales),
                total_gross_sales: (item.status == "canceled" ? -1 : 1) * parseFloat(gross_sales),
                complimentary,
                status: "pending"
              });
            } else {
              items[isExist].quantity += (item.status == "canceled" ? -1 : 1) * item.qty;
              items[isExist].subtotal += (item.status == "canceled" ? -1 : 1) * item.subtotal;
              items[isExist].total_discount += (item.status == "canceled" ? -1 : 1) * discount_price;
              items[isExist].total_revenue += (item.status == "canceled" ? -1 : 1) * revenue_item;
              items[isExist].total_revenue_sales += (item.status == "canceled" ? -1 : 1) * parseFloat(revenue_sales);
              items[isExist].total_bill_discount += (item.status == "canceled" ? -1 : 1) * parseFloat(bill_discount);
              items[isExist].total_tax += (item.status == "canceled" ? -1 : 1) * parseFloat(tax);
              items[isExist].total_service_charge += (item.status == "canceled" ? -1 : 1) * parseFloat(service_charge);
              items[isExist].total_revenue_net_sales += (item.status == "canceled" ? -1 : 1) * parseFloat(revenue_net_sales);
              items[isExist].total_gross_sales += (item.status == "canceled" ? -1 : 1) * parseFloat(gross_sales);
            }
          });
          items.forEach((menu) => {
            const isExistCategoryItem = reportItem.findIndex((item) => item?.category_item_id === menu?.items?.item_category_id);

            if (isExistCategoryItem !== -1) {
              reportItem[isExistCategoryItem].qty += Number(menu?.quantity);
              reportItem[isExistCategoryItem].revenue_item += Number(menu?.total_revenue);
              reportItem[isExistCategoryItem].item_discount += Number(menu?.total_discount);
              reportItem[isExistCategoryItem].revenue_sales += Number(menu?.total_revenue_sales);
              reportItem[isExistCategoryItem].bill_discount += Number(menu?.total_bill_discount);
              reportItem[isExistCategoryItem].tax += Number(menu?.total_tax);
              reportItem[isExistCategoryItem].service_charge += Number(menu?.total_service_charge);
              reportItem[isExistCategoryItem].revenue_net_sales += menu?.total_revenue_sales - menu?.total_bill_discount;
              reportItem[isExistCategoryItem].gross_sales += menu?.total_gross_sales;

              const isExistItem = reportItem[isExistCategoryItem].items.findIndex((item) => item?.id === menu?.items?.id);
              if (isExistItem !== -1) {
                reportItem[isExistCategoryItem].items[isExistItem].qty += Number(menu?.quantity);
                reportItem[isExistCategoryItem].items[isExistItem].revenue_item += Number(menu?.total_revenue);
                reportItem[isExistCategoryItem].items[isExistItem].item_discount += Number(menu?.total_discount);
                reportItem[isExistCategoryItem].items[isExistItem].revenue_sales += Number(menu?.total_revenue_sales);
                reportItem[isExistCategoryItem].items[isExistItem].bill_discount += Number(menu?.total_bill_discount);
                reportItem[isExistCategoryItem].items[isExistItem].tax += Number(menu?.total_tax);
                reportItem[isExistCategoryItem].items[isExistItem].service_charge += Number(menu?.total_service_charge);
                reportItem[isExistCategoryItem].items[isExistItem].revenue_net_sales += Number(menu?.total_revenue_sales - menu?.total_bill_discount);
                reportItem[isExistCategoryItem].items[isExistItem].gross_sales += Number(menu?.total_gross_sales);
              } else {
                reportItem[isExistCategoryItem].items.push({
                  id: menu?.items?.id,
                  name: menu?.items?.name,
                  qty: Number(menu?.quantity),
                  revenue_item: Number(menu?.total_revenue),
                  item_discount: Number(menu?.total_discount),
                  revenue_sales: Number(menu?.total_revenue_sales),
                  bill_discount: Number(menu?.total_bill_discount),
                  tax: Number(menu?.total_tax),
                  service_charge: Number(menu?.total_service_charge),
                  revenue_net_sales: Number(menu?.total_revenue_sales - menu?.total_bill_discount),
                  gross_sales: Number(menu?.total_gross_sales),
                });
              }
            } else {
              reportItem.push({
                category_name: menu?.items?.item_category?.name,
                category_item_id: menu?.items?.item_category_id,
                qty: Number(menu?.quantity),
                revenue_item: Number(menu?.total_revenue),
                item_discount: Number(menu?.total_discount),
                revenue_sales: Number(menu?.total_revenue_sales),
                bill_discount: Number(menu?.total_bill_discount),
                tax: Number(menu?.total_tax),
                service_charge: Number(menu?.total_service_charge),
                revenue_net_sales: Number(menu?.total_revenue_sales - menu?.total_bill_discount),
                gross_sales: Number(menu?.total_gross_sales),
                items: [{
                  id: menu?.items?.id,
                  name: menu?.items?.name,
                  qty: Number(menu?.quantity),
                  revenue_item: Number(menu?.total_revenue),
                  item_discount: Number(menu?.total_discount),
                  revenue_sales: Number(menu?.total_revenue_sales),
                  bill_discount: Number(menu?.total_bill_discount),
                  tax: Number(menu?.total_tax),
                  service_charge: Number(menu?.total_service_charge),
                  revenue_net_sales: Number(menu?.total_revenue_sales - menu?.total_bill_discount),
                  gross_sales: Number(menu?.total_gross_sales),
                }],
              });
            }
          });
        });
        return reportItem;
      },
      pagination() {
        return {
          currentPage: this.currentPage,
          totalPages: this.totalPages,
          itemsPerPage: this.itemsPerPage,
        };
      },
      salesOrderData() {
        return this.allSalesOrders.slice(
          (this.pagination.currentPage - 1) * this.pagination.itemsPerPage,
          this.pagination.currentPage * this.pagination.itemsPerPage
        );
      },
      tax() {
        const settings = this.allSettings.length > 0 ? this.allSettings[0] : {};
        return Number(settings.tax);
      },
      serviceCharge() {
        const settings = this.allSettings.length > 0 ? this.allSettings[0] : {};
        return Number(settings.service_charge);
      },
      summaryOrder() {
        let items = [];
        this.allSalesOrders?.forEach((order) => {
          order?.menus?.forEach((item) => {
            const complimentary = item?.complimentary ? true : false;
            let isExist = items?.findIndex((i) => {
              const icompliment = i?.complimentary ? true : false;
              return i?.item_id == item?.item_id && icompliment === complimentary;
            });

            if (isExist == -1) {
              items.push({
                ...item,
                quantity: (item.status == "canceled" ? -1 : 1) * Number(item.qty),
                subtotal: (item.status == "canceled" ? -1 : 1) * parseFloat(item.price) * Number(item.qty),
                grand_total: (item.status == "canceled" ? -1 : 1) * (parseFloat(item.price) - parseFloat(item.discount_price)) * Number(item.qty),
                status: "pending"
              });
            } else {
              items[isExist].quantity += (item.status == "canceled" ? -1 : 1) * Number(item.qty);
              items[isExist].subtotal += (item.status == "canceled" ? -1 : 1) * parseFloat(item.price) * Number(item.qty);
              items[isExist].grand_total += (item.status == "canceled" ? -1 : 1) * (parseFloat(item.price) - parseFloat(item.discount_price)) * Number(item.qty);
            }
          });
        });
        return items;
      },
      totalSalesOrders() {
        return this.allSalesOrders.reduce((total, item) => total + Number(item.grand_total || 0), 0);
      },
      totalRevenueSales() {
        return this.summaryOrder?.filter((item) => !item?.complimentary).reduce((total, item) => total + (parseFloat(item.price || 0) - parseFloat(item.discount_price)) * Number(item.quantity), 0);
      },
      totalTax() {
        return this.allSalesOrders.reduce((total, item) => total + Number(item.tax || 0), 0);
      },
      totalServiceCharge() {
        return this.allSalesOrders.reduce((total, item) => total + Number(item.service_charge || 0), 0);
      },
      totalDiscount() {
        return this.allSalesOrders.reduce((total, item) => total + Number(item.global_discount_amount || 0), 0);
      },
      totalComplimentary() {
        return this.summaryOrder?.filter((item) => item?.complimentary).reduce((total, item) => total + (parseFloat(item.price || 0) - parseFloat(item.discount_price)) * Number(item.quantity), 0);
      },
      totalNetSales() {
        return this.totalRevenueSales - this.totalDiscount + this.totalServiceCharge + this.totalTax;
      },
      averageTransaction() {
        return this.allSalesOrders.length > 0
          ? this.totalNetSales / this.allSalesOrders.length
          : 0;
      },
      totalPax() {
        return this.allSalesOrders.reduce((total, item) => total + Number(item.pax || 0), 0);
      },
    },
    beforeUnmount() {
      try {
        if (this.socket) {
          // Remove all listeners to prevent memory leaks
          this.socket.removeAllListeners();
          this.socket.disconnect();
          this.socket = null;
        }
        this.isConnected = false;
        this.listTransaction = [];
        this.messages = [];
      } catch (error) {
        console.error("Error during cleanup:", error);
      }
    },
    watch: {
      currentPage: {
        immediate: true,
        handler(newVal) {
          let params = {};
          if (this.filter.capacity) {
            params.capacity = this.filter.capacity;
          }

          if (this.filter.type) {
            params.order_type = this.filter.type;
          }

          if (this.filter.status) {
            params.status = this.filter.status;
          }

          if (this.filter.marketing_id) {
            params.marketing_id = this.filter.marketing_id;
          }

          if (this.filter.payment_method_id) {
            params.payment_method_id = this.filter.payment_method_id;
          }

          if (this.filter.global_discount_id) {
            params.global_discount_id = this.filter.global_discount_id;
          }

          if (this.filter.item_category_id) {
            params.item_category_id = this.filter.item_category_id;
          }

          if (this.filter.table_id) {
            params.table_id = this.filter.table_id;
          }

          if (this.filter.cash_register_id) {
            params.cash_register_id = this.filter.cash_register_id;
          }

          if (this.filter.rangeDate) {
            let startDate = new Date(this.filter.rangeDate[0].getTime() + 25200000); // Start from 00:00:00
            let endDate = new Date(new Date(this.filter.rangeDate[1]).getTime() + 25200000 + 86399000); // Plus 23:59:59 (in milliseconds)
            params.start_date = startDate;
            params.end_date = endDate;
          }
          this.fetchSalesOrders(params);
          this.currentPage = newVal;
        },
      },
    },
    methods: {
      formatRupiah,
      formatDate,
      formateISODate,
      toggleDropdown() {
        this.isDropdownOpen = !this.isDropdownOpen;
      },
      formatPrintItem(qty = true, revenue = true) {
        let printerText = ``;
        const rows = [];
        const report = this.reportItem;

        // Add company header with center alignment
        rows.push("\x1b\x61\x01"); // Center alignment
        rows.push(process.env.VUE_APP_STORE_NAME);
        rows.push(process.env.VUE_APP_STORE_ADDRESS);
        rows.push(process.env.VUE_APP_STORE_PHONE);
        rows.push(print.breakLine(40, " "));
        rows.push("Sales By Category");


        report?.forEach((category) => {
          rows.push(print.breakLine(40, "="));
          rows.push("\x1b\x61\x01"); // Center alignment
          rows.push(print.oneLine(`${category?.category_name}:`, 40));
          rows.push("\x1b\x61\x00"); // Left alignment
          rows.push(print.breakLine(40, "="));
          const items = category?.items;

          items.forEach((item) => {
            rows.push(print.twoColumn(`${item?.name}`, `${revenue ? this.formatRupiah(item?.revenue_item) : ""} ${qty ? `[${item?.qty}]` : ""}`, 17, 6, 17));
          });

          rows.push(print.breakLine(40, " "));
          rows.push(print.breakLine(40, "="));
          if (qty) {
            rows.push(print.twoColumn(`Total QTY ${category?.category_name} :`, `${category?.qty}`, 17, 6, 17));
          }
          if (revenue) {
            rows.push(print.twoColumn(`Total Sales ${category?.category_name} :`, `${this.formatRupiah(category?.revenue_item)}`, 17, 6, 17));
          }
          rows.push(print.breakLine(40, "="));
        });

        rows.push(`Jam Cetak: \t ${new Date().toLocaleString()}`);
        rows.push("\n\n\n"); // Extra lines for paper cut
        printerText = rows.join("\n");
        return printerText;
      },
      async fetchSalesOrders(params = {}) {
        const { data } = await this.$store.dispatch('reports/fetchAllSalesOrders', { ...params, limit: 10000000 });
        this.allSalesOrders = data;
        this.totalPages = data.length > 0 ? Math.ceil(data.length / this.pagination.itemsPerPage) : 1;
      },
      async fetchAdditionalData() {
        await this.$store.dispatch('tables/fetchTables', { limit: 1000 });
        await this.$store.dispatch('marketings/fetchMarketings', { limit: 1000 });
        await this.$store.dispatch('petty_cash/fetchPettyCashes');
        await this.$store.dispatch('item_categories/fetchItemCategories', { limit: 1000 });
        await this.$store.dispatch('payment_methods/fetchPaymentMethods', { limit: 1000 });
        await this.$store.dispatch("settings/fetchSettings", { limit: 1000 });
        await this.$store.dispatch("global_discounts/fetchGlobalDiscounts", { limit: 1000 });
      },
      connectWebSocket() {
        try {
          this.socket = io(process.env.VUE_APP_WEBSOCKET_URL, {
            reconnection: true, // Enable auto-reconnection
            reconnectionAttempts: 5, // Maximum number of reconnection attempts
            timeout: 10000, // Connection timeout in milliseconds
          });

          this.socket.on("connect_error", (error) => {
            this.messages.push(error.message);
            this.isConnected = false;
          });

          this.socket.on("disconnect", (reason) => {
            this.messages.push(reason);
            this.isConnected = false;
          });

          // Menerima pesan dari server
          this.socket.on("serverMessage", (data) => {
            this.handleWebSocketMessage(data);
            this.messages.push(data.message);
          });

          this.socket.on("welcome", (data) => {
            this.messages.push(data.message);
          });

          this.socket.on("new_items", (order) => {
            this.handleWebSocketMessage(order);
          });

          this.socket.on("update_items", (order) => {
            this.handleWebSocketMessage(order);
          });

          this.socket.on("delete_items", (order) => {
            this.handleWebSocketMessage(order);
          });

          this.socket.on("connect", () => {
            this.isConnected = true;
          });

          this.socket.on("error", (error) => {
            this.messages.push(error.message);
            this.isConnected = false;
          });

          this.handleReconnect();
        } catch (error) {
          this.isConnected = false;
        }
      },
      sendMessage() {
        // Kirim pesan ke server
        this.socket.emit("clientMessage", this.message);
        this.message = ""; // Reset input
      },
      handleWebSocketMessage(data) {
        this.isLoading = true;
        try {
          let index;

          // Validasi data terlebih dahulu
          if (!data || !data.type) {
            return;
          }

          switch (data.type) {
            case "INITIAL_DATA":
              if (Array.isArray(data.transactions)) {
                this.listTransaction = data.transactions;
                this.fetchSalesOrders();
              } else {
                console.warn("Invalid transactions data format:", data);
              }
              break;
            case "NEW_ITEMS":
              if (data.items && data.route == "sales-order") {
                this.listTransaction.unshift(data.items);
                this.fetchSalesOrders();
              }
              break;
            case "UPDATE_ITEMS":
              if (data.items && data.items.id && data.route == "sales-order") {
                index = this.listTransaction.findIndex(
                  (t) => t.id === data.items.id
                );
                if (index !== -1) {
                  this.listTransaction.splice(index, 1, data.items);
                }
                this.fetchSalesOrders();
              }
              break;
            case "DELETE_ITEMS":
              if (data.id && data.route == "sales-order") {
                this.listTransaction = this.listTransaction.filter(
                  (transaction) => String(transaction.id) !== String(data.id)
                );
                this.fetchSalesOrders();
              }
              break;
            default:
              console.warn("Unknown message type:", data.type);
          }
        } catch (error) {
          console.error("Error handling websocket message:", error);
        } finally {
          this.isLoading = false;
        }
      },
      handleReconnect() {
        if (this.socket) {
          this.socket.on("reconnect_attempt", (attemptNumber) => {
            console.log(`Reconnection attempt ${attemptNumber}`);
          });

          this.socket.on("reconnect", () => {
            console.log("Reconnected successfully");
            this.isConnected = true;
            // Mungkin perlu memuat ulang data
            this.socket.emit("requestInitialData");
          });

          this.socket.on("reconnect_failed", () => {
            console.log("Failed to reconnect");
            this.isConnected = false;
          });
        }
      },
      showModal() {
        this.modalShowFilterTransaction = true;
        this.isBlur = true;
      },
      closeModal() {
        setTimeout(() => {
          this.modalShowFilterTransaction = false;
          this.isBlur = false;
        }, 200);
      },
      submitFilter(filter) {
        let params = {};
        if (filter.capacity) {
          params.capacity = filter.capacity;
        }

        if (filter.type) {
          params.order_type = filter.type;
        }

        if (filter.status) {
          params.status = filter.status;
        }

        if (filter.marketing_id) {
          params.marketing_id = filter.marketing_id;
        }

        if (filter.payment_method_id) {
          params.payment_method_id = filter.payment_method_id;
        }

        if (filter.global_discount_id) {
          params.global_discount_id = filter.global_discount_id;
        }

        if (filter.item_category_id) {
          params.item_category_id = filter.item_category_id;
        }

        if (filter.table_id) {
          params.table_id = filter.table_id;
        }

        if (filter.cash_register_id) {
          params.cash_register_id = filter.cash_register_id;
        }

        if (filter.rangeDate) {
          let startDate = new Date(filter.rangeDate[0].getTime() + 25200000); // Start from 00:00:00
          let endDate = new Date(new Date(filter.rangeDate[1]).getTime() + 25200000 + 86399000); // Plus 23:59:59 (in milliseconds)
          params.start_date = startDate;
          params.end_date = endDate;
        }

        this.fetchSalesOrders(params);

        this.updateFilter(filter);
      },
      updateFilter(filter) {
        this.filter = filter;
      },
      async printItemReport(qty = true, revenue = true) {
        try {

          // Convert the element to text format suitable for ESC/POS
          const printText = this.formatPrintItem(qty, revenue);
          console.log("printText:", printText);

          // Send to backend printer endpoints
          const print_url =
            process.env.VUE_APP_ROOT_API + "/printer/printing/custom-print";

          const response = await axios.post(print_url, {
            text: printText,
            printer_ip: process.env.VUE_APP_CASIER_IP,
          });

          // Optional: Show success message
          console.log("Print job sent successfully", response);
        } catch (error) {
          console.error("Print error:", error);
          this.errorMessage = "Failed to print: " + error.message;
          this.showErrorDialog = true;
        }
      },
      printSalesByCategory() {
        let startDate = null;
        let endDate = null;
        const { dateRange } = this.countPeriode(this.allSalesOrders);
        console.log("dateRange", dateRange);
        if (dateRange) {
          startDate = dateRange[0]; // Start from 00:00:00
          endDate = dateRange[1]; // Plus 23:59:59 (in milliseconds)
        }
        const reportData = this.reportItem; // Your report data
        printPdfReportItem.generateSalesByCategoryReport(
          reportData,
          {
            companyName: process.env.VUE_APP_STORE_NAME || 'Nama Toko Anda',
            companyAddress: process.env.VUE_APP_STORE_ADDRESS || 'Alamat Toko',
            companyPhone: process.env.VUE_APP_STORE_PHONE || '0812-3456-7890',
            startDate: startDate ? startDate : '-', // Set your start date
            endDate: endDate ? endDate : '-', // Set your end date
          }
        );
      },
      printPaymentReport() {
        let startDate = null;
        let endDate = null;
        const sumCashPayment = this.allSalesOrders.reduce((total, order) => total + (order?.payment_method?.is_cash_register ? Number(order?.payment_amount) : 0), 0);
        const sumCashChange = this.allSalesOrders.reduce((total, order) => total + (order?.payment_method?.is_cash_register ? Number(order?.payment_change) : 0), 0);
        const sumCashQty = this.allSalesOrders.reduce((total, order) => total + (order?.payment_method?.is_cash_register ? 1 : 0), 0);
        const sumCashPax = this.allSalesOrders.reduce((total, order) => total + (order?.payment_method?.is_cash_register ? order?.pax : 0), 0);

        const { dateRange } = this.countPeriode(this.allSalesOrders);
        if (dateRange) {
          startDate = dateRange[0]; // Start from 00:00:00
          endDate = dateRange[1]; // Plus 23:59:59 (in milliseconds)
        }
        let reportData = this.allSalesOrders.filter((order) => (order.status === "paid" && !order?.payment_method?.name?.toLowerCase().includes("hutang")) || (order?.payment_method?.name?.toLowerCase().includes("hutang") && order?.is_paid_off)).map((order, index) => {
          return {
            no: index + 1,
            code: order?.code,
            table: order?.table?.name || '-',
            payment_method: order?.payment_method?.name || '-',
            due_date: formatDate(order?.createdAt) || '-',
            customer_name: order?.customer_name || '-',
            grand_total: formatRupiah(order?.grand_total) || 0,
            payment_amount: formatRupiah(order?.payment_amount) || 0,
            payment_change: formatRupiah(order?.payment_change) || 0,
            cashier: order?.cashier_updated?.name || '-'
          }
        }); // Your report data
        const tableHeader = [
          { header: 'No', dataKey: 'no' },
          { header: 'KODE', dataKey: 'code' },
          { header: 'Room', dataKey: 'table' },
          { header: 'Metode Pembayaran', dataKey: 'payment_method' },
          { header: 'Tanggal', dataKey: 'due_date' },
          { header: 'Customer', dataKey: 'customer_name' },
          { header: 'Tot. Bill', dataKey: 'grand_total' },
          { header: 'Tot. Income', dataKey: 'payment_amount' },
          { header: 'Change', dataKey: 'payment_change' },
          { header: 'Cashier', dataKey: 'cashier' },
        ];

        const tableColumnStyle = {
          0: { cellWidth: 6 },   // Nomer
          1: { cellWidth: 16 },  // Kode
          2: { cellWidth: 14 },  // Table
          3: { cellWidth: 16 },  // Metode Pembayaran
          4: { cellWidth: 18 },  // Tgl Bayar
          5: { cellWidth: 30 },  // Nama Pelanggan
          6: { cellWidth: 20, halign: 'right' },  // Total
          7: { cellWidth: 20, halign: 'right' },  // Terbayar
          8: { cellWidth: 20, halign: 'right' },  // kembalian
          9: { cellWidth: 25 }  // cashier
        };

        const summaryTableData = [
          [
            { text: 'Cash Receive' },
            { text: ':' },
            { text: formatRupiah(sumCashPayment), align: 'right' },
            { text: '', align: 'right' },
            { text: '', align: 'right' },
          ],
          [
            { text: 'Cash Change' },
            { text: ':' },
            { text: formatRupiah(sumCashChange), align: 'right', border: { bottom: true, color: [0, 0, 0] } },
            { text: '', align: 'right', border: { bottom: true, color: [0, 0, 0] } },
            { text: '', align: 'right', border: { bottom: true, color: [0, 0, 0] } },
          ],
          [
            { text: 'Total Cash' },
            { text: ' ' },
            { text: formatRupiah(sumCashPayment + sumCashChange), align: 'right' },
            { text: sumCashQty, align: 'right' },
            { text: sumCashPax, align: 'right' },
          ],
          [
            { text: '' },
            { text: ' ' },
            { text: '', align: 'right' },
            { text: '', align: 'right' },
          ],
        ];

        let paymentMethod = this.allPaymentMethods.filter((pm) => !pm?.is_cash_register);
        let totalComplimentary = 0;
        let totalQtyComplimentary = 0;
        let totalPaxComplimentary = 0;

        paymentMethod = paymentMethod?.map((pm) => {
          let total = 0;
          let qty = 0;
          let totalPax = 0;

          const order_paid = this.allSalesOrders?.filter((order) => (pm?.id === order?.payment_method_id && ((order.status === "paid" && !pm?.name?.toLowerCase().includes("hutang")) || (pm?.name?.toLowerCase().includes("hutang") && order?.is_paid_off))));

          order_paid?.forEach((order) => {

            // Add order items
            let items = [];
            order?.menus?.forEach((item) => {
              const complimentary = item?.complimentary ? true : false;
              let isExist = items?.findIndex((i) => {
                const icompliment = i?.complimentary ? true : false;
                return i?.item_id == item?.item_id && icompliment === complimentary && i?.discount_applied == item?.discount_applied && i?.tax_applied == item?.tax_applied && i?.service_charge_applied == item?.service_charge_applied && i?.discount_price == item?.discount_price && i?.price == item?.price;
              });

              const isExistGlobalDiscount = this.allGlobalDiscounts?.find((i) => i?.id == order?.global_discount_id)?.amount;
              const service_charge_applied = order?.menus?.find((i) => i?.item_id == item?.item_id && i?.status === "pending")?.service_charge_applied;
              const tax_applied = order?.menus?.find((i) => i?.item_id == item?.item_id && i?.status === "pending")?.tax_applied;
              const discount_applied = order?.menus?.find((i) => i?.item_id == item?.item_id && i?.status === "pending")?.discount_applied;

              const discount_price = parseFloat(item?.discount_price) * Number(item?.qty);
              const revenue_item = parseFloat(item?.price) * Number(item?.qty);
              const revenue_sales = (parseFloat(item?.price) - parseFloat(item?.discount_price)) * Number(item?.qty);
              const bill_discount = isExistGlobalDiscount && discount_applied ? (parseFloat(isExistGlobalDiscount) * parseFloat(revenue_sales) / 100) : 0;
              const tax = tax_applied ? parseFloat(revenue_sales) * Number(this.tax) / 100 : 0;
              const service_charge = service_charge_applied ? (parseFloat(revenue_sales) - parseFloat(bill_discount)) * Number(this.serviceCharge) / 100 : 0;
              const revenue_net_sales = revenue_sales + tax + service_charge - bill_discount;

              if (isExist == -1) {
                items.push({
                  ...item,
                  quantity: (item.status == "canceled" ? -1 : 1) * item.qty,
                  subtotal: (item.status == "canceled" ? -1 : 1) * revenue_sales,
                  discount_price: (item.status == "canceled" ? -1 : 1) * discount_price,
                  revenue_item: (item.status == "canceled" ? -1 : 1) * revenue_item,
                  revenue_sales: (item.status == "canceled" ? -1 : 1) * revenue_sales,
                  bill_discount: (item.status == "canceled" ? -1 : 1) * bill_discount,
                  tax: (item.status == "canceled" ? -1 : 1) * tax,
                  service_charge: (item.status == "canceled" ? -1 : 1) * service_charge,
                  revenue_net_sales: (item.status == "canceled" ? -1 : 1) * revenue_net_sales,
                  complimentary,
                  status: "pending"
                });
              } else {
                items[isExist].quantity += (item.status == "canceled" ? -1 : 1) * item.qty;
                items[isExist].subtotal += (item.status == "canceled" ? -1 : 1) * revenue_sales;
                items[isExist].discount_price += (item.status == "canceled" ? -1 : 1) * discount_price;
                items[isExist].revenue_item += (item.status == "canceled" ? -1 : 1) * revenue_item;
                items[isExist].revenue_sales += (item.status == "canceled" ? -1 : 1) * revenue_sales;
                items[isExist].bill_discount += (item.status == "canceled" ? -1 : 1) * bill_discount;
                items[isExist].tax += (item.status == "canceled" ? -1 : 1) * tax;
                items[isExist].service_charge += (item.status == "canceled" ? -1 : 1) * service_charge;
                items[isExist].revenue_net_sales += (item.status == "canceled" ? -1 : 1) * revenue_net_sales;
              }
            });

            const isComplimentary = items?.some((menu) => menu?.complimentary === true);
            // const revenue_item_without_complimentary = items?.filter((menu) => menu?.status !== "canceled" && menu?.complimentary !== true)?.reduce((sum, menu) => sum + Number(menu?.price || 0), 0);
            // const item_discount_without_complimentary = items?.filter((menu) => menu?.status !== "canceled" && menu?.complimentary !== true)?.reduce((sum, menu) => sum + Number(menu?.discount_price || 0), 0);
            // const bill_discount_without_complimentary = Number(order?.global_discount_amount || 0);
            // const revenue_sales_without_complimentary = (revenue_item_without_complimentary - item_discount_without_complimentary) + Number(order?.service_charge || 0) + Number(order?.tax || 0);
            // const revenue_net_sales_without_complimentary = revenue_sales_without_complimentary ? revenue_sales_without_complimentary - bill_discount_without_complimentary : 0;

            // const revenue_item_complimentary = items?.filter((menu) => menu?.status !== "canceled" && menu?.complimentary)?.reduce((sum, menu) => sum + Number(menu?.price || 0), 0);
            // const item_discount_complimentary = items?.filter((menu) => menu?.status !== "canceled" && menu?.complimentary)?.reduce((sum, menu) => sum + Number(menu?.discount_price || 0), 0);
            // const bill_discount_complimentary = Number(order?.global_discount_amount || 0);
            // const revenue_sales_complimentary = revenue_item_complimentary - item_discount_complimentary;
            // const revenue_net_sales_complimentary = revenue_sales_complimentary ? revenue_sales_complimentary - bill_discount_complimentary : 0;

            const revenueNetSales = items?.filter((item) => !item?.complimentary)?.reduce((sum, item) => {
              return sum + parseFloat(item?.revenue_net_sales || 0)
            }, 0);

            const revenueNetSalesComplimentary = items?.filter((item) => item?.complimentary)?.reduce((sum, item) => {
              return sum + parseFloat(item?.revenue_net_sales || 0)
            }, 0);

            if (!isComplimentary) {
              qty += 1;
              totalPax += order?.pax;
              total += revenueNetSales;
            } else {
              totalPaxComplimentary += order?.pax;
              totalQtyComplimentary += 1;
              totalComplimentary += revenueNetSalesComplimentary;
            }
          });
          return {
            ...pm,
            total: total,
            qty: qty,
            pax: totalPax,
            paxComplimentary: totalPaxComplimentary
          }
        });

        let addSummary = [];
        if (paymentMethod?.length > 0) {

          paymentMethod?.forEach((pm) => {
            addSummary.push([
              { text: `Total ${pm?.name?.toLowerCase().includes("hutang") ? "Hutang Terbayar" : pm?.name}` },
              { text: ':' },
              { text: formatRupiah(pm.total), align: 'right' },
              { text: pm.qty, align: 'right' },
              { text: pm.pax, align: 'right' },
            ]);
          });

          const totalAll = sumCashChange + sumCashPayment + paymentMethod?.reduce((total, pm) => total + Number(pm?.total), 0);
          const totalQty = paymentMethod?.reduce((total, pm) => total + Number(pm?.qty), 0) + sumCashQty;
          const totalPax = paymentMethod?.reduce((total, pm) => total + Number(pm?.pax), 0);

          addSummary.push([
            { text: 'Total Complimentary' },
            { text: '' },
            { text: formatRupiah(totalComplimentary), align: 'right' },
            { text: totalQtyComplimentary, align: 'right' },
            { text: totalPaxComplimentary, align: 'right' },
          ],);

          addSummary.push([
            { text: 'Total' },
            { text: '' },
            { text: formatRupiah(totalAll), align: 'right', border: { top: true, color: [0, 0, 0] } },
            { text: totalQty, align: 'right', border: { top: true, color: [0, 0, 0] } },
            { text: totalPax + totalPaxComplimentary, align: 'right', border: { top: true, color: [0, 0, 0] } },
          ],);
        }
        const summaryTableHeader = ['Tipe', ' ', 'Total', 'Qty', 'PAX'];

        printPdf.generateAccountsReceivableReport(
          {
            tableHeader,
            reportData,
            tableColumnStyle,
            summaryTableData: {
              summaryTableHeader,
              summaryTableData: paymentMethod?.length > 0 ? [...summaryTableData, ...addSummary] : summaryTableData
            }
          },
          {
            title: 'Payment Report',
            startDate: startDate ? startDate : '-', // Set your start date
            endDate: endDate ? endDate : '-', // Current date
            fontSizeTable: 6
          }
        );
      },
      printTransactionReport() {
        let startDate = null;
        let endDate = null;
        const { dateRange } = this.countPeriode(this.allSalesOrders);
        if (dateRange) {
          startDate = dateRange[0]; // Start from 00:00:00
          endDate = dateRange[1]; // Plus 23:59:59 (in milliseconds)
        }
        let totalDiscMenu = 0;
        let totalDiscBill = 0;
        let totalServiceCharge = 0;
        let totalTax = 0;
        let totalGrandTotal = 0;
        let reportData = this.allSalesOrders.map((order, index) => {
          const totalItem = order?.menus?.reduce((total, menu) => total + ((Number(menu?.price || 0) - Number(menu?.discount_price || 0)) * Number(menu?.qty || 0)), 0);
          const discMenu = order?.menus?.reduce((total, menu) => total + (Number(menu?.discount_price || 0) * Number(menu?.qty || 0)), 0);
          totalDiscMenu += discMenu;
          totalDiscBill += Number(order?.global_discount_amount || 0);
          totalServiceCharge += Number(order?.service_charge || 0);
          totalTax += Number(order?.tax || 0);
          totalGrandTotal += Number(order?.grand_total || 0);
          return {
            no: index + 1,
            code: order?.code,
            table: order?.table?.name || '-',
            due_date: formatDate(order?.createdAt) || '-',
            time_span: timeSpan(order?.createdAt, order?.updatedAt) || '-',
            customer_name: order?.customer_name || '-',
            sub_total: formatRupiah(order?.sub_total) || 0,
            discount_menu: formatRupiah(discMenu) || 0,
            discount_bill: formatRupiah(order?.global_discount_amount) || 0,
            service_charge: formatRupiah(order?.service_charge) || 0,
            tax: formatRupiah(order?.tax) || 0,
            total_item: formatRupiah(totalItem) || 0,
            grand_total: formatRupiah(order?.grand_total) || 0,
            payment_amount: formatRupiah(order?.payment_amount) || 0,
            payment_change: formatRupiah(order?.payment_change) || 0,
            payment_method: order?.payment_method?.name || '-',
            cashier: order?.cashier_updated?.name || '-'
          }
        }); // Your report data
        
        const tableHeader = [
          { header: 'No', dataKey: 'no' },
          { header: 'KODE', dataKey: 'code' },
          { header: 'Room', dataKey: 'table' },
          { header: 'Tanggal', dataKey: 'due_date' },
          { header: 'Customer', dataKey: 'customer_name' },
          { header: 'Sub Total', dataKey: 'sub_total' },
          { header: 'Disc. Menu', dataKey: 'discount_menu' },
          { header: 'Disc. Bill', dataKey: 'discount_bill' },
          { header: 'Service Charge', dataKey: 'service_charge' },
          { header: 'Tax', dataKey: 'tax' },
          { header: 'Total Item', dataKey: 'total_item' },
          { header: 'Tot. Bill', dataKey: 'grand_total' },
          { header: 'Grand Total', dataKey: 'grand_total' },
          { header: 'Metode Pembayaran', dataKey: 'payment_method' },
          { header: 'Cashier', dataKey: 'cashier' },
        ];

        const tableColumnStyle = {
          0: { cellWidth: 6 },   // No
          1: { cellWidth: 16 },  // Kode
          2: { cellWidth: 14 },  // Table
          3: { cellWidth: 18 },  // Tgl Bayar
          4: { cellWidth: 25 },  // Nama Pelanggan
          5: { cellWidth: 20, halign: 'right' },  // Sub Total
          6: { cellWidth: 20, halign: 'right' },  // Disc. Menu
          7: { cellWidth: 20, halign: 'right' },  // Disc. Bill
          8: { cellWidth: 20, halign: 'right' },  // Service Charge
          9: { cellWidth: 20, halign: 'right' },  // Tax
          10: { cellWidth: 20, halign: 'right' },  // Total Item
          11: { cellWidth: 20, halign: 'right' },  // Tot. Bill
          12: { cellWidth: 20, halign: 'right' },  // Grand Total
          13: { cellWidth: 14 },  // Metode Pembayaran
          14: { cellWidth: 20 }  // cashier
        };

        const summary = [
          { label: 'Total Disc. Menu', value: this.formatRupiah(totalDiscMenu) },
          { label: 'Total Disc. Bill', value: this.formatRupiah(totalDiscBill) },
          { label: 'Total Service Charge', value: this.formatRupiah(totalServiceCharge) },
          { label: 'Total Tax', value: this.formatRupiah(totalTax) },
          { label: 'Total Grand Total', value: this.formatRupiah(totalGrandTotal) },
          { label: 'Total Net Sales', value: this.formatRupiah(totalGrandTotal - totalDiscMenu - totalDiscBill - totalServiceCharge - totalTax) },

        ];
        printPdf.generateAccountsReceivableReport(
          {
            tableHeader,
            reportData,
            tableColumnStyle,
            summary,
          },
          {
            title: 'Sales Report',
            startDate: startDate ? startDate : '-', // Set your start date
            endDate: endDate ? endDate : '-', // Current date
            fontSizeTable: 6,
            orientation: 'landscape'
          }
        );
      },
      countPeriode(allSalesOrders) {
        // Group sales orders by date
        const salesByDay = allSalesOrders?.reduce((acc, order) => {
          if (!order?.createdAt) return acc;
          const date = order.createdAt.split('T')[0]; // Extract YYYY-MM-DD from ISO string
          if (!acc[date]) {
            acc[date] = [];
          }
          acc[date].push(order);
          return acc;
        }, {});

        // Calculate total days with sales
        const totalSalesDays = Object.keys(salesByDay || {}).length || 0;

        // Get all unique dates
        const allDates = Object.keys(salesByDay || {}).sort();
        const dateRange = allDates.length > 0 ? [allDates[0], allDates[allDates.length - 1]] : [];

        return {
          dateRange,
          totalSalesDays
        };
      },
      printRingkasanPenjualan() {
        const settings = this.allSettings.length > 0 ? this.allSettings[0] : {};
        this.summaryCashRegister = calculateAllOrderSummary(this.allSalesOrders, this.allPaymentMethods, this.allItemCategories, this.allTables, settings, this.allGlobalDiscounts);

        const { dateRange, totalSalesDays } = this.countPeriode(this.allSalesOrders);

        const overallData = [];
        overallData.push([
          { text: 'Item Sales' },
          { text: ':' },
          { text: formatRupiah(this.summaryCashRegister.revenue_item), align: 'right' },
        ]);
        overallData.push([
          { text: 'Item Discount' },
          { text: ':' },
          { text: formatRupiah(this.summaryCashRegister.item_discount), align: 'right', border: { bottom: true, color: [0, 0, 0] } },
        ]);
        overallData.push([
          { text: 'Item Net Sales' },
          { text: ':' },
          { text: formatRupiah(this.summaryCashRegister.revenue_sales), align: 'right' },
        ]);
        overallData.push([
          { text: 'Bill Discount' },
          { text: ':' },
          { text: formatRupiah(this.summaryCashRegister.bill_discount), align: 'right', border: { bottom: true, color: [0, 0, 0] } },
        ]);
        overallData.push([
          { text: 'Total Sales' },
          { text: ':' },
          { text: formatRupiah(this.summaryCashRegister.total_sales), align: 'right' },
        ]);
        overallData.push([
          { text: 'Total Service Charge' },
          { text: ':' },
          { text: formatRupiah(this.summaryCashRegister.total_service_charge), align: 'right' },
        ]);
        overallData.push([
          { text: 'Total Tax' },
          { text: ':' },
          { text: formatRupiah(this.summaryCashRegister.total_tax), align: 'right', border: { bottom: true, color: [0, 0, 0] } },
        ]);
        overallData.push([
          { text: 'Gross Sales' },
          { text: ':' },
          { text: formatRupiah(this.summaryCashRegister.revenue_net_sales), align: 'right' },
        ]);
        overallData.push([
          { text: '' },
          { text: '' },
          { text: '' },
        ]);
        overallData.push([
          { text: 'Total # of Item' },
          { text: ':' },
          { text: this.summaryCashRegister.total_item, align: 'right' },
        ]);
        overallData.push([
          { text: 'Total # of of Bills' },
          { text: ':' },
          { text: this.summaryCashRegister.total_bill, align: 'right' },
        ]);
        overallData.push([
          { text: 'Sales per Bill' },
          { text: ':' },
          { text: formatRupiah(this.summaryCashRegister.revenue_sales_per_bill), align: 'right' },
        ]);
        overallData.push([
          { text: 'Total # of of Guests' },
          { text: ':' },
          { text: this.summaryCashRegister.total_bill, align: 'right' },
        ]);
        overallData.push([
          { text: 'Sales per Guest' },
          { text: ':' },
          { text: formatRupiah(this.summaryCashRegister.revenue_sales_per_bill), align: 'right' },
        ]);
        overallData.push([
          { text: 'Sales w/o SC' },
          { text: ':' },
          { text: formatRupiah(this.summaryCashRegister.revenue_sales_without_service_charge), align: 'right' },
        ]);
        overallData.push([
          { text: 'Sales w/o Tax' },
          { text: ':' },
          { text: formatRupiah(this.summaryCashRegister.revenue_sales_without_tax), align: 'right' },
        ]);
        overallData.push([
          { text: 'Cancel With Order' },
          { text: ':' },
          { text: this.summaryCashRegister.total_qty_cancel_item, align: 'right' },
        ]);
        overallData.push([
          { text: 'Total Amount' },
          { text: ':' },
          { text: formatRupiah(this.summaryCashRegister.revenue_cancel_item), align: 'right' },
        ]);
        overallData.push([
          { text: 'Void # Payment' },
          { text: ':' },
          { text: this.summaryCashRegister.total_qty_void_sales, align: 'right' },
        ]);
        overallData.push([
          { text: 'Void Amount' },
          { text: ':' },
          { text: formatRupiah(this.summaryCashRegister.revenue_void_sales), align: 'right' },
        ]);

        let summaryOverall = {
          summaryTableHeader: [],
          summaryTableColumnWidths: [40, 4, 40],
          summaryTableData: overallData,
          options: {
            title: 'Overall Summary',
            showHeader: false,
            rowHeight: 10,
            fontSize: 8,
          }
        };

        const typeOrder = ['dine_in', 'take_away', 'delivery', 'staff'];

        let typeOrderData = [];

        typeOrder.forEach((type) => {
          let isAllowAdd = true;
          this.summaryCashRegister?.sales_by_type?.forEach((item) => {
            if (item.type == type) {
              typeOrderData.push([
                { text: item.type },
                { text: item?.qty },
                { text: formatRupiah(item.gross_sales), align: 'right' },
                { text: Math.round(item?.qty / totalSalesDays), align: 'right' },
                { text: formatRupiah(item.gross_sales / totalSalesDays), align: 'right' },
              ]);
              isAllowAdd = false;
            }
          });
          if (isAllowAdd) {
            typeOrderData.push([
              { text: type },
              { text: 0 },
              { text: formatRupiah(0), align: 'right' },
              { text: 0, align: 'right' },
              { text: formatRupiah(0), align: 'right' },
            ]);
          }
        });

        typeOrderData.push([
          { text: 'Grand Total' },
          { text: this.summaryCashRegister?.sales_by_type?.reduce((total, item) => total + Number(item?.qty || 0), 0), align: 'right' },
          { text: formatRupiah(this.summaryCashRegister?.sales_by_type?.reduce((total, item) => total + parseFloat(item?.revenue_net_sales || 0), 0)), align: 'right' },
          { text: Math.round(this.summaryCashRegister?.sales_by_type?.reduce((total, item) => total + Number(item?.qty || 0), 0) / totalSalesDays), align: 'right' },
          { text: formatRupiah(this.summaryCashRegister?.sales_by_type?.reduce((total, item) => total + parseFloat(item?.revenue_net_sales || 0), 0) / totalSalesDays), align: 'right' },
        ])

        let billSummary = {
          summaryTableHeader: ['Type', 'Qty', 'Revenue', 'Qty / Day', 'Revenue / Day'],
          summaryTableColumnWidths: [40, 10, 30, 30, 30],
          summaryTableData: typeOrderData,
          options: {
            title: 'Bill Summary',
            showHeader: true,
            rowHeight: 10,
            fontSize: 8,
          }
        };

        const paymentType = this.allPaymentMethods;

        let paymentTypeData = [];

        const totalSalesQuantity = this.summaryCashRegister?.sales_by_payment_type?.reduce((total, item) => total + Number(item?.sales_quantity || 0), 0);
        const totalPaymentAmount = this.summaryCashRegister?.sales_by_payment_type?.reduce((total, item) => total + Number(item?.payment_amount || 0), 0);
        const totalPaymentChange = this.summaryCashRegister?.sales_by_payment_type?.reduce((total, item) => total + Number(item?.payment_change || 0), 0);
        const totalPaymentBalance = this.summaryCashRegister?.sales_by_payment_type?.reduce((total, item) => total + Number(item?.payment_balance || 0), 0);

        paymentType.forEach((type) => {
          let isAllowAdd = true;
          if (type?.name?.toLowerCase().includes("hutang")) {
            return;
          }
          this.summaryCashRegister?.sales_by_payment_type?.forEach((item) => {
            const paymentPercentage = (parseFloat(item?.payment_balance) / parseFloat(totalPaymentBalance)) * 100;
            if (item?.payment_type == type?.id) {
              paymentTypeData.push([
                { text: item.payment_method_name },
                { text: item?.sales_quantity },
                { text: formatRupiah(item?.payment_amount), align: 'right' },
                { text: formatRupiah(item?.payment_change), align: 'right' },
                { text: formatRupiah(item?.payment_balance), align: 'right' },
                { text: `${parseFloat(paymentPercentage).toFixed(2)} %`, align: 'right' },
              ]);
              isAllowAdd = false;
            }
          });
          if (isAllowAdd) {
            paymentTypeData.push([
              { text: type?.name },
              { text: 0 },
              { text: formatRupiah(0), align: 'right' },
              { text: formatRupiah(0), align: 'right' },
              { text: formatRupiah(0), align: 'right' },
              { text: `${parseFloat(0 / totalPaymentBalance * 100).toFixed(2)} %`, align: 'right' },
            ]);
          }
        });

        this.summaryCashRegister?.sales_by_payment_type?.forEach((item) => {
          if (item?.payment_method_name?.toLowerCase().includes("hutang")) {
            const paymentPercentage = (parseFloat(item?.payment_balance) / parseFloat(totalPaymentBalance)) * 100;
            paymentTypeData.push([
              { text: item.payment_method_name },
              { text: item?.sales_quantity },
              { text: formatRupiah(item?.payment_amount), align: 'right' },
              { text: formatRupiah(item?.payment_change), align: 'right' },
              { text: formatRupiah(item?.payment_balance), align: 'right' },
              { text: `${parseFloat(paymentPercentage).toFixed(2)} %`, align: 'right' },
            ]);
          }
        });

        paymentTypeData.push([
          { text: 'Grand Total' },
          { text: totalSalesQuantity },
          { text: formatRupiah(totalPaymentAmount), align: 'right' },
          { text: formatRupiah(totalPaymentChange), align: 'right' },
          { text: formatRupiah(totalPaymentBalance), align: 'right' },
          { text: `${parseFloat(totalPaymentBalance / totalPaymentBalance * 100).toFixed(2)} %`, align: 'right' },
        ])

        let paymentTypeSummary = {
          summaryTableHeader: ['Type', '#Paid', 'Paid Amount', 'Change', 'Total', '%/All'],
          summaryTableColumnWidths: [30, 25, 25, 25, 25, 25],
          summaryTableData: paymentTypeData,
          options: {
            title: 'Payment Type Summary',
            showHeader: true,
            rowHeight: 10,
            fontSize: 8,
          }
        };

        let salesByDayData = [];

        const totalSalesQtyDays = this.summaryCashRegister?.sales_by_type?.reduce((total, item) => total + Number(item?.qty || 0), 0);
        const totalSalesItem = this.summaryCashRegister?.sales_by_type?.reduce((total, item) => total + Number(item?.revenue_item || 0), 0);
        const totalSalesNetSales = this.summaryCashRegister?.sales_by_type?.reduce((total, item) => total + Number(item?.revenue_net_sales || 0), 0);

        typeOrder.forEach((type) => {
          let isAllowAdd = true;
          this.summaryCashRegister?.sales_by_type?.forEach((item) => {
            if (item.type == type) {
              salesByDayData.push([
                { text: item.type },
                { text: item?.qty },
                { text: `${parseFloat(item?.qty / totalSalesQtyDays * 100).toFixed(2)} %`, align: 'right' },
                { text: formatRupiah(item?.revenue_item), align: 'right' },
                { text: `${parseFloat(item?.revenue_item / totalSalesItem * 100).toFixed(2)} %`, align: 'right' },
                { text: formatRupiah(item?.item_discount), align: 'right' },
                { text: formatRupiah(item?.bill_discount), align: 'right' },
                { text: formatRupiah(item.revenue_net_sales), align: 'right' },
                { text: `${parseFloat(item?.revenue_net_sales / totalSalesNetSales * 100).toFixed(2)} %`, align: 'right' },
              ]);
              isAllowAdd = false;
            }
          });
          if (isAllowAdd) {
            salesByDayData.push([
              { text: type },
              { text: 0 },
              { text: `${parseFloat(0 / totalSalesQtyDays * 100).toFixed(2)} %`, align: 'right' },
              { text: formatRupiah(0), align: 'right' },
              { text: `${parseFloat(0 / totalSalesItem * 100).toFixed(2)} %`, align: 'right' },
              { text: formatRupiah(0), align: 'right' },
              { text: formatRupiah(0), align: 'right' },
              { text: formatRupiah(0), align: 'right' },
              { text: `${parseFloat(0 / totalSalesNetSales * 100).toFixed(2)} %`, align: 'right' },
            ]);
          }
        });

        let salesByTypeSummary = {
          summaryTableHeader: ['Type', 'Qty', '%', 'Item Sales', '%', 'Discount Item', 'Discount Bill', 'Net Sales', '%'],
          summaryTableColumnWidths: [10, 25, 15, 25, 15, 25, 25, 25, 25],
          summaryTableData: salesByDayData,
          options: {
            showHeader: true,
            rowHeight: 10,
            fontSize: 8,
            title: 'Sales By Type Summary',
          }
        };

        let salesByCategoryData = [];

        const totalSalesCategoryItem = this.summaryCashRegister?.sales_by_category_item?.reduce((total, item) => total + Number(item?.qty || 0), 0);
        const totalSalesCategoryItemRevenue = this.summaryCashRegister?.sales_by_category_item?.reduce((total, item) => total + Number(item?.revenue_item || 0), 0);
        const totalSalesCategoryItemNetSales = this.summaryCashRegister?.sales_by_category_item?.reduce((total, item) => total + Number(item?.revenue_net_sales || 0), 0);
        const totalSalesCategoryItemDiscount = this.summaryCashRegister?.sales_by_category_item?.reduce((total, item) => total + Number(item?.item_discount || 0), 0);
        const totalSalesCategoryItemBillDiscount = this.summaryCashRegister?.sales_by_category_item?.reduce((total, item) => total + Number(item?.bill_discount || 0), 0);

        this.allItemCategories.forEach((category) => {
          let isAllowAdd = true;
          this.summaryCashRegister?.sales_by_category_item?.forEach((item) => {
            if (item.category_item_id == category?.id) {
              salesByCategoryData.push([
                { text: item.category_name },
                { text: item?.qty },
                { text: `${parseFloat(item?.qty / totalSalesCategoryItem * 100).toFixed(2)} %`, align: 'right' },
                { text: formatRupiah(item?.revenue_item), align: 'right' },
                { text: `${parseFloat(item?.revenue_item / totalSalesCategoryItemRevenue * 100).toFixed(2)} %`, align: 'right' },
                { text: formatRupiah(item?.item_discount), align: 'right' },
                { text: formatRupiah(item?.bill_discount), align: 'right' },
                { text: formatRupiah(item.revenue_net_sales), align: 'right' },
                { text: `${parseFloat(item?.revenue_net_sales / totalSalesCategoryItemNetSales * 100).toFixed(2)} %`, align: 'right' },
              ]);
              isAllowAdd = false;
            }
          });
          if (isAllowAdd) {
            salesByCategoryData.push([
              { text: category?.name },
              { text: 0 },
              { text: `${parseFloat(0 / totalSalesCategoryItem * 100).toFixed(2)} %`, align: 'right' },
              { text: formatRupiah(0), align: 'right' },
              { text: `${parseFloat(0 / totalSalesCategoryItemRevenue * 100).toFixed(2)} %`, align: 'right' },
              { text: formatRupiah(0), align: 'right' },
              { text: formatRupiah(0), align: 'right' },
              { text: formatRupiah(0), align: 'right' },
              { text: `${parseFloat(0 / totalSalesCategoryItemNetSales * 100).toFixed(2)} %`, align: 'right' },
            ]);
          }
        });

        salesByCategoryData.push([
          { text: 'Grand Total' },
          { text: totalSalesCategoryItem },
          { text: `${parseFloat(totalSalesCategoryItem / totalSalesCategoryItem * 100).toFixed(2)} %`, align: 'right' },
          { text: formatRupiah(totalSalesCategoryItemRevenue), align: 'right' },
          { text: `${parseFloat(totalSalesCategoryItemRevenue / totalSalesCategoryItemRevenue * 100).toFixed(2)} %`, align: 'right' },
          { text: formatRupiah(totalSalesCategoryItemDiscount), align: 'right' },
          { text: formatRupiah(totalSalesCategoryItemBillDiscount), align: 'right' },
          { text: formatRupiah(totalSalesCategoryItemNetSales), align: 'right' },
          { text: `${parseFloat(totalSalesCategoryItemNetSales / totalSalesNetSales * 100).toFixed(2)} %`, align: 'right' },
        ])

        let salesByCategorySummary = {
          summaryTableHeader: ['Type', 'Qty', '%', 'Item Sales', '%', 'Discount Item', 'Discount Bill', 'Net Sales', '%'],
          summaryTableColumnWidths: [15, 15, 15, 25, 15, 25, 25, 25, 25],
          summaryTableData: salesByCategoryData,
          options: {
            showHeader: true,
            rowHeight: 10,
            fontSize: 8,
            title: 'Sales By Category',
          }
        };

        let salesByGlobalDiscountData = [];

        const totalSalesGlobalDiscount = this.summaryCashRegister?.sales_by_global_discount?.reduce((total, item) => total + Number(item?.qty || 0), 0);
        const totalSalesGlobalDiscountRevenue = this.summaryCashRegister?.sales_by_global_discount?.reduce((total, item) => total + Number(item?.revenue_item || 0), 0);
        const totalSalesGlobalDiscountItemDiscount = this.summaryCashRegister?.sales_by_global_discount?.reduce((total, item) => total + Number(item?.item_discount || 0), 0);
        const totalSalesGlobalDiscountBillDiscount = this.summaryCashRegister?.sales_by_global_discount?.reduce((total, item) => total + Number(item?.bill_discount || 0), 0);
        const totalSalesGlobalDiscountNetSales = this.summaryCashRegister?.sales_by_global_discount?.reduce((total, item) => total + Number(item?.revenue_net_sales || 0), 0);

        this.summaryCashRegister?.sales_by_global_discount?.forEach((item) => {
          salesByGlobalDiscountData.push([
            { text: item.type },
            { text: item?.qty },
            { text: `${parseFloat(item?.qty / totalSalesGlobalDiscount * 100).toFixed(2)} %`, align: 'right' },
            { text: formatRupiah(item?.revenue_item), align: 'right' },
            { text: `${parseFloat(item?.revenue_item / totalSalesGlobalDiscountRevenue * 100).toFixed(2)} %`, align: 'right' },
            { text: formatRupiah(item?.item_discount), align: 'right' },
            { text: formatRupiah(item?.bill_discount), align: 'right' },
            { text: formatRupiah(item.revenue_net_sales), align: 'right' },
            { text: `${parseFloat(item?.revenue_net_sales / totalSalesGlobalDiscountNetSales * 100).toFixed(2)} %`, align: 'right' },
          ]);
        });

        salesByGlobalDiscountData.push([
          { text: 'Grand Total' },
          { text: totalSalesGlobalDiscount },
          { text: `${parseFloat(totalSalesGlobalDiscount / totalSalesGlobalDiscount * 100).toFixed(2)} %`, align: 'right' },
          { text: formatRupiah(totalSalesGlobalDiscountRevenue), align: 'right' },
          { text: `${parseFloat(totalSalesGlobalDiscountRevenue / totalSalesGlobalDiscountRevenue * 100).toFixed(2)} %`, align: 'right' },
          { text: formatRupiah(totalSalesGlobalDiscountItemDiscount), align: 'right' },
          { text: formatRupiah(totalSalesGlobalDiscountBillDiscount), align: 'right' },
          { text: formatRupiah(totalSalesGlobalDiscountNetSales), align: 'right' },
          { text: `${parseFloat(totalSalesGlobalDiscountNetSales / totalSalesGlobalDiscountNetSales * 100).toFixed(2)} %`, align: 'right' },
        ])

        let salesByGlobalDiscountSummary = {
          summaryTableHeader: ['Type', 'Qty', '%', 'Item Sales', '%', 'Discount Item', 'Discount Bill', 'Net Sales', '%'],
          summaryTableColumnWidths: [15, 15, 15, 25, 15, 25, 25, 25, 25],
          summaryTableData: salesByGlobalDiscountData,
          options: {
            showHeader: true,
            rowHeight: 10,
            fontSize: 8,
            title: 'Sales By Global Discount',
          }
        };

        let salesByGlobalDiscountBillData = [];
        const totalSalesGlobalDiscountBill = this.summaryCashRegister?.sales_by_global_discount?.reduce((total, item) => total + Number(item?.sales_quantity || 0), 0);
        const totalSalesGlobalDiscountBillRevenue = this.summaryCashRegister?.sales_by_global_discount?.reduce((total, item) => total + Number(item?.revenue_item || 0), 0);
        const totalSalesGlobalDiscountBillItemDiscount = this.summaryCashRegister?.sales_by_global_discount?.reduce((total, item) => total + Number(item?.item_discount || 0), 0);
        const totalSalesGlobalDiscountBillBillDiscount = this.summaryCashRegister?.sales_by_global_discount?.reduce((total, item) => total + Number(item?.bill_discount || 0), 0);
        const totalSalesGlobalDiscountBillNetSales = this.summaryCashRegister?.sales_by_global_discount?.reduce((total, item) => total + Number(item?.revenue_net_sales || 0), 0);

        this.summaryCashRegister?.sales_by_global_discount?.forEach((item) => {
          salesByGlobalDiscountBillData.push([
            { text: item.type },
            { text: item?.sales_quantity },
            { text: `${parseFloat(item?.sales_quantity / totalSalesGlobalDiscountBill * 100).toFixed(2)} %`, align: 'right' },
            { text: formatRupiah(item?.revenue_item), align: 'right' },
            { text: `${parseFloat(item?.revenue_item / totalSalesGlobalDiscountBillRevenue * 100).toFixed(2)} %`, align: 'right' },
            { text: formatRupiah(item?.item_discount), align: 'right' },
            { text: formatRupiah(item?.bill_discount), align: 'right' },
            { text: formatRupiah(item.revenue_net_sales), align: 'right' },
            { text: `${parseFloat(item?.revenue_net_sales / totalSalesGlobalDiscountBillNetSales * 100).toFixed(2)} %`, align: 'right' },
          ]);
        });


        salesByGlobalDiscountBillData.push([
          { text: 'Grand Total' },
          { text: totalSalesGlobalDiscountBill },
          { text: `${parseFloat(totalSalesGlobalDiscountBill / totalSalesGlobalDiscountBill * 100).toFixed(2)} %`, align: 'right' },
          { text: formatRupiah(totalSalesGlobalDiscountBillRevenue), align: 'right' },
          { text: `${parseFloat(totalSalesGlobalDiscountBillRevenue / totalSalesGlobalDiscountBillRevenue * 100).toFixed(2)} %`, align: 'right' },
          { text: formatRupiah(totalSalesGlobalDiscountBillItemDiscount), align: 'right' },
          { text: formatRupiah(totalSalesGlobalDiscountBillBillDiscount), align: 'right' },
          { text: formatRupiah(totalSalesGlobalDiscountBillNetSales), align: 'right' },
          { text: `${parseFloat(totalSalesGlobalDiscountBillNetSales / totalSalesGlobalDiscountBillNetSales * 100).toFixed(2)} %`, align: 'right' },
        ])

        let salesByGlobalDiscountBillSummary = {
          summaryTableHeader: ['Type', 'Qty', '%', 'Item Sales', '%', 'Discount Item', 'Discount Bill', 'Net Sales', '%'],
          summaryTableColumnWidths: [15, 15, 15, 25, 15, 25, 25, 25, 25],
          summaryTableData: salesByGlobalDiscountBillData,
          options: {
            showHeader: true,
            rowHeight: 10,
            fontSize: 8,
            title: 'Sales By Global Discount Bill',
          }
        };


        printPdfRingkasanPenjualan.generateReport([
          { ...summaryOverall },
          { ...billSummary },
          { ...paymentTypeSummary },
          { ...salesByTypeSummary },
          { ...salesByCategorySummary },
          { ...salesByGlobalDiscountSummary },
          { ...salesByGlobalDiscountBillSummary },
        ], {
          startDate: dateRange[0],
          endDate: dateRange[1],
        });
      }
    }
  };
</script>
